/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const TextIcon = ({color}: {color?:string}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
    >
      <path
        d="M14 1.57999C14 1.31477 13.8946 1.06042 13.7071 0.87288C13.5196 0.685344 13.2652 0.579987 13 0.579987H1C0.734784 0.579987 0.48043 0.685344 0.292893 0.87288C0.105357 1.06042 0 1.31477 0 1.57999C0 1.8452 0.105357 2.09956 0.292893 2.28709C0.48043 2.47463 0.734784 2.57999 1 2.57999H6V13.58C6 13.8452 6.10536 14.0996 6.29289 14.2871C6.48043 14.4746 6.73478 14.58 7 14.58C7.26522 14.58 7.51957 14.4746 7.70711 14.2871C7.89464 14.0996 8 13.8452 8 13.58V2.57999H13C13.2652 2.57999 13.5196 2.47463 13.7071 2.28709C13.8946 2.09956 14 1.8452 14 1.57999ZM19 6.57999H13C12.7348 6.57999 12.4804 6.68534 12.2929 6.87288C12.1054 7.06042 12 7.31477 12 7.57999C12 7.8452 12.1054 8.09956 12.2929 8.28709C12.4804 8.47463 12.7348 8.57999 13 8.57999H15V13.58C15 13.8452 15.1054 14.0996 15.2929 14.2871C15.4804 14.4746 15.7348 14.58 16 14.58C16.2652 14.58 16.5196 14.4746 16.7071 14.2871C16.8946 14.0996 17 13.8452 17 13.58V8.57999H19C19.2652 8.57999 19.5196 8.47463 19.7071 8.28709C19.8946 8.09956 20 7.8452 20 7.57999C20 7.31477 19.8946 7.06042 19.7071 6.87288C19.5196 6.68534 19.2652 6.57999 19 6.57999Z"
        fill={color? color: "black"}

      />
    </svg>
  )
}
